import { Collapsable, Link, P } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactInfo } from '../../../../../interfaces/ContactInfo';
import { SubsidiaryContactInfos } from '../../../../../interfaces/SubsidiaryContactInfos';
import { StyledCollapsable, StyledCollapseArrow, StyledContentDiv, StyledLabelP, StyledLaunchIcon, StyledLink, StyledSectionDiv } from './SubsidiaryLink.styles';

export interface SubsidiaryLinkProps {
  subsidiary: SubsidiaryContactInfos;
}

const SubsidiaryLink: FC<SubsidiaryLinkProps> = ({ subsidiary }) => {
  const { t } = useTranslation('PersonalInformationsIntroductionPage');
  const getInfo = (info: ContactInfo): string => info.information ? info.information + t('infoSeparator') : null;
  if (!subsidiary) return null;
  return (
    <StyledCollapsable name={subsidiary.title}>
      <Collapsable.Target>
        {({ toggle, isCollapsed }) => (
          <>
            <StyledCollapseArrow isCollapsed={isCollapsed} />
            <StyledLink onClick={toggle}>{subsidiary.title}</StyledLink>
          </>
        )}
      </Collapsable.Target>
      <Collapsable.Content>
        <StyledContentDiv>
          {subsidiary.phoneNumbers?.length > 0 &&
            <StyledSectionDiv>
              <StyledLabelP>{t('phoneLabel')}</StyledLabelP>
              {subsidiary.phoneNumbers?.map((x, i) => <P key={i}>{getInfo(x)}<Link href={`tel:+${x.value}`} target="top">{x.display}</Link></P>)}
            </StyledSectionDiv>}
          {subsidiary.emails?.length > 0 &&
            <StyledSectionDiv>
              <StyledLabelP>{t('emailLabel')}</StyledLabelP>
              {subsidiary.emails?.map((x, i) => <P key={i}>{getInfo(x)}<Link href={`mailto:${x.value}`} target="top">{x.display}</Link></P>)}
            </StyledSectionDiv>}
          {subsidiary.urls?.length > 0 &&
            <StyledSectionDiv>
              <StyledLabelP>{t('websiteLabel')}</StyledLabelP>
              {subsidiary.urls?.map((x, i) => <P key={i}><Link href={x.value} target="_blank">{x.display}<StyledLaunchIcon /></Link></P>)}
            </StyledSectionDiv>}
        </StyledContentDiv>
      </Collapsable.Content>
    </StyledCollapsable>
  );
};

export default SubsidiaryLink;
